<script setup lang="ts">
import DirectoryContextMenuItems from '@/dashboard/vue/components/contexts/DirectoryContextMenu/DirectoryContextMenuItems.vue';
import CopySharedLinkButton from '@/dashboard/vue/components/project/CopySharedLinkButton.vue';
import TeamChanger from '@/dashboard/vue/components/project/TeamChanger.vue';
import VisibilityChanger from '@/dashboard/vue/components/project/VisibilityChanger.vue';
import TitlePanel from '@/dashboard/vue/components/TitlePanel.vue';
import { getProjectVisibilityType } from '../../../../types/project_visibility';
import { usePublicTitlePanel } from '@/dashboard/vue/components/public/PublicTitlePanel/usePublicTitlePanel';
import FolderIcon from '@/dashboard/vue/components/icons/FolderIcon.vue';

const { project, canAddUsers, canShowMenu, team, isSharedPanel, owner, addUser } = usePublicTitlePanel();
</script>

<template>
  <TitlePanel :title="project?.name ?? ''" :show-menu="canShowMenu">
    <template #components>
      <!-- Laptop variant start -->
      <!-- Laptop variant start -->
      <div v-if="!isSharedPanel" class="hidden items-center justify-start gap-s laptop:flex">
        <div class="flex items-center">
          <VisibilityChanger
            :current="getProjectVisibilityType(project)"
            :owner="project?.is_owner ?? false"
            :editable="false"
            :is-workspace="false"
          />
          <div v-if="project?.allow_public" class="ml-[17px] flex items-center">
            <CopySharedLinkButton />
          </div>
        </div>
        <TeamChanger :editable="canAddUsers" :owner="true" :team="team" :add-action="() => addUser()" />
      </div>
      <!-- Laptop variant end -->
      <!-- Mobile variant start -->
      <div v-if="!isSharedPanel" class="flex w-full items-center justify-between gap-s py-s laptop:hidden">
        <div class="flex flex-col gap-xs">
          <VisibilityChanger
            :current="getProjectVisibilityType(project)"
            :owner="project?.is_owner ?? false"
            :editable="false"
            :is-workspace="false"
          />
          <TeamChanger :editable="canAddUsers" :owner="true" :team="team" :add-action="() => addUser()" />
        </div>
        <div v-if="project?.allow_public">
          <CopySharedLinkButton />
        </div>
      </div>
      <!-- Mobile variant end -->
      <div v-else class="flex h-[56px] w-full items-center justify-between gap-s laptop:h-auto laptop:w-auto laptop:justify-start">
        <span class="flex items-center gap-xs">
          <FolderIcon class="stroke-black dark:stroke-gray-500" />
          <span class="text-[14px] text-black dark:text-gray-500">Owner: {{ owner?.name }}</span>
        </span>
      </div>
    </template>
    <template #menu-body>
      <DirectoryContextMenuItems v-if="project" :id="project.id" />
    </template>
  </TitlePanel>
</template>
